module.exports = __webpack_public_path__ + "static/pcc-a92f52e306cdaa75fe1119309c83ff19.mp4";